/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Input} from '@angular/core';
import {StateService} from '@uirouter/core';
import {ToastrService} from 'ngx-toastr';

import template from './library-creative-context-actions.component.html';
import {SignalAdminResourcePageState} from '../common/controller/signal-admin-resource-page-state';
import {LibraryCreativeCopyModalService} from './library-creative-copy-modal.service';
import {LibraryCreativeLinkCreativeModalService} from './library-creative-link-creative-modal.service';
import {LibraryCreativeModel} from './library-creative-api.service';
import {AdvertisingSharedModule} from '../advertising/advertising-shared.module';

@Component({
  standalone: true,
  imports: [AdvertisingSharedModule],
  selector: 'adn-library-creative-context-actions',
  template
})
export class LibraryCreativeContextActionsComponent {
  @Input() state: SignalAdminResourcePageState<LibraryCreativeModel>;
  @Input() blockDelete: any;

  constructor(
    private readonly $state: StateService,
    private readonly toastr: ToastrService,
    private readonly copyModalService: LibraryCreativeCopyModalService,
    private readonly linkCreativeModalService: LibraryCreativeLinkCreativeModalService
  ) {
  }

  createCreative(): void {
    const model = this.state?.model();
    if (this.state?.readOnly() || this.blockDelete || !model) {
      return;
    }
    this.linkCreativeModalService.open({
      model,
      onComplete: (result) => {
        if (result.destination && result.creativeId) {
          this.$state.go('app.adv.creatives.creative', {id: result.creativeId});
        } else if (result.creativeId) {
          this.toastr.success(
            'A creative linking to this library creative was successfully created.',
            'Creative Created'
          );
        }
      }
    });
  }

  copy(): void {
    const model = this.state?.model();
    if (this.state?.readOnly() || this.blockDelete || !model) {
      return;
    }
    this.copyModalService.open({
      model,
      onComplete: (result) => {
        if (result.destination && result.creativeId) {
          this.$state.go('app.adv.library-creatives.library-creative', {id: result.creativeId});
        } else if (result.creativeId) {
          this.toastr.success(
            'A copy of this library creative was successfully created.',
            'Library Creative Copied'
          );
        }
      }
    });
  }
}
